module.exports = __webpack_public_path__ + "static/6-open-source-principle-2addc8a50f92df2ec487b8b0b54daf78.jpg";